import React from 'react';
import PropTypes from 'prop-types';
import Button from '@material-ui/core/Button';
import Dialog from '@material-ui/core/Dialog';
import DialogActions from '@material-ui/core/DialogActions';
import DialogContent from '@material-ui/core/DialogContent';
import DialogContentText from '@material-ui/core/DialogContentText';
import DialogTitle from '@material-ui/core/DialogTitle';
import withMobileDialog from '@material-ui/core/withMobileDialog';
import Grid from '@material-ui/core/Grid';
import TextField from '@material-ui/core/TextField';
import { withStyles } from '@material-ui/core/styles';
import Divider from '@material-ui/core/Divider';
import Login from './Login.js';
import FormControl from '@material-ui/core/FormControl';
import FormControlLabel from '@material-ui/core/FormControlLabel';
import CircularProgress from '@material-ui/core/CircularProgress';

const styles = theme => ({
    container: {
        display: 'flex',
        flexWrap: 'wrap',
    },
    error: {
        backgroundColor: theme.palette.error.dark,
    },
    title: {
        color: "rgb(37,106,167)",
        textAlign: 'center',
        fontFamily: [
            'Typo Round',
            'Open Sans',
            'sans-serif'

        ].join(','),
        fontSize: '28px',
    },
    new_user_text: {
        color: "rgba(0, 0, 0, 0.54)",
        padding: '0px',
        margin: '0px',
        paddingTop: '10px',
        // textAlign:'center',
        fontFamily: [

            'Open Sans',
            'sans-serif'

        ].join(','),
        fontSize: '16px',
    },
    textFieldLabel: {
        // color: "red",
        textAlign: "center",
        fontFamily: [
            'Open Sans',
            'sans-serif'

        ].join(','),
    },
    textField: {
        // marginLeft: theme.spacing.unit,
        // marginRight: theme.spacing.unit,
        // // width: 50,

        color: "#203b60",
        textAlign: "center",

        fontFamily: [
            'Open Sans',
            'sans-serif'

        ].join(','),
        '&:hover': {
            color: 'red',
            borderColor: 'red',
        },
    },
    MtextField: {
        marginLeft: theme.spacing.unit,
        marginRight: theme.spacing.unit,
        // width: 50,

        color: "#203b60",
        fontSize: "18px",
        textAlign: "center",

        fontFamily: [
            'Open Sans',
            'sans-serif'

        ].join(','),
    },
    dense: {
        marginTop: 19,
    },
    menu: {
        width: 200,
    },
    paperRoot: {
        ...theme.mixins.gutters(),
        paddingTop: theme.spacing.unit * 2,
        paddingBottom: theme.spacing.unit * 2,
        marginBottom: '15px',
        width: '100%',

    },
    paperImp: {
        ...theme.mixins.gutters(),
        paddingTop: theme.spacing.unit * 2,
        paddingBottom: theme.spacing.unit * 2,
        // marginTop: '15px'
        // width:'100%'
    },
    group: {
        margin: `${theme.spacing.unit}px 0`,
        flexDirection: 'row'
    },
    root: {
        padding: 0,
        marginBottom: '1px'



    },
    buttons: {
        display: 'flex',
        justifyContent: 'flex-end',
    },
    button: {
        // margin: theme.spacing.unit,
        // boxShadow: 'none',
        textTransform: 'none',

        // fontWeight:'800',
        fontSize: 16,
        fontWeight: '600',
        padding: '3px 6px',
        border: '1px solid',
        color: 'white',
        // lineHeight: 1.5,
        backgroundColor: 'rgb(37,106,167)',
        borderColor: 'rgb(37,106,167)',
        fontFamily: [
            'Open Sans',
            'sans-serif'

        ].join(','),
        '&:hover': {
            backgroundColor: '#203b60',
            borderColor: '#203b60',
        },
        '&:active': {
            boxShadow: 'none',
            backgroundColor: '#0062cc',
            borderColor: '#005cbf',
        },
    },
    formButtons: {
        marginTop: theme.spacing.unit * 2
    },
    buttonBack: {
        // margin: theme.spacing.unit,
        // boxShadow: 'none',
        textTransform: 'none',
        fontSize: 16,
        marginRight: '10px',
        // fontWeight:'800',
        padding: '3px 6px',
        // border: '1px solid',
        color: '#203b60',
        // lineHeight: 1.5,
        backgroundColor: '#f2f2f2',
        // borderColor: 'rgb(114, 165,199)',
        fontFamily: [
            'Open Sans',
            'sans-serif'

        ].join(','),
        // '&:hover': {
        //   backgroundColor: '#203b60',
        //   borderColor: '#203b60',
        // },
        // '&:active': {
        //   boxShadow: 'none',
        //   backgroundColor: '#0062cc',
        //   borderColor: '#005cbf',
        // },
    },

    progress:{
        margin: theme.spacing.unit * 2,
    }

});



class BudgetRequest extends React.Component {
    constructor(props) {
        super(props);
        this.state = {
            new_user: false,
            company: "",
            name: "",
            email: ""
        }
        this.confirm = this.confirm.bind(this);
        this.setNewUserForm = this.setNewUserForm.bind(this);
        this.handleTextField = this.handleTextField.bind(this);
    }

    handleClickOpen = () => {
        this.setState({ open: true });
    };

    handleClose = () => {
        this.setState({
            new_user: false
        })
        this.props.close()
    };

    setNewUserForm() {
        this.setState({
            new_user: true
        })
    }

    confirm(e) {
        e.preventDefault()
        // alert("Submit")
        this.props.confirm(this.state)
    }

    handleTextField(event) {

        const name = event.target.name;
        this.setState({
            [name]: event.target.value
        });

    }

    render() {
        const { fullScreen } = this.props;
        const { classes } = this.props;

        return (
            <div>
                {/* <Button variant="outlined" color="primary" onClick={this.handleClickOpen}>
          Open responsive dialog
        </Button> */}
                <Dialog
                    fullScreen={fullScreen}
                    open={this.props.open}
                    onClose={this.handleClose}
                    aria-labelledby="responsive-dialog-title"
                >
                    {/* <DialogTitle classes={{ root: classes.title }} disableTypography id="responsive-dialog-title">{"Iniciar Sesión"}</DialogTitle> */}
                    <DialogContent>
                        <DialogContentText>
                            {this.props.loading === false &&
                             <React.Fragment>Por favor, ingrese sus datos y en unos minutos le enviaremos su cotización por correo electrónico.</React.Fragment>
                            }
                            {this.props.loading === true &&
                             <React.Fragment>Aguarde un instante, estamos procesando su solicitud</React.Fragment>
                            }
                           
                        </DialogContentText>

                    {this.props.loading === false &&
                        <form onSubmit={this.confirm}>
                            <Grid>
                                <Grid item xs={12} >

                                    <TextField
                                        required
                                        id="company"
                                        name="company"
                                        label="Empresa"
                                        fullWidth
                                        required
                                        onChange={this.handleTextField}
                                        // autoComplete="fname"
                                        InputProps={{
                                            classes: {
                                                root: classes.textField,
                                                input: { textAlign: 'center' }
                                            },
                                        }}
                                        InputLabelProps={{
                                            classes: {
                                                root: classes.textFieldLabel,
                                            },
                                        }}
                                    />

                                </Grid>
                                <Grid item xs={12} >
                                    <TextField
                                        required
                                        id="name"
                                        name="name"
                                        label="Nombre"
                                        fullWidth
                                        required
                                        onChange={this.handleTextField}
                                        // autoComplete="fname"
                                        InputProps={{
                                            classes: {
                                                root: classes.textField,
                                                input: { textAlign: 'center' }
                                            },
                                        }}
                                        InputLabelProps={{
                                            classes: {
                                                root: classes.textFieldLabel,
                                            },
                                        }}
                                    />
                                </Grid>
                                


                                <Grid item xs={12} >
                                    <TextField
                                        required
                                        id="email"
                                        name="email"
                                        label="Correo electrónico"
                                        fullWidth
                                        type="email"
                                        required
                                        onChange={this.handleTextField}
                                        // autoComplete="fname"
                                        InputProps={{
                                            classes: {
                                                root: classes.textField,
                                                input: { textAlign: 'center' }
                                            },
                                        }}
                                        InputLabelProps={{
                                            classes: {
                                                root: classes.textFieldLabel,
                                            },
                                        }}
                                    />
                                </Grid>

                                <Grid container
                                    spacing={900}
                                    alignItems={'flex-end'}
                                    direction={'row'}
                                    justify={'flex-end'}
                                    className={classes.formButtons}
                                    item xs={12} >
                                    <Button onClick={this.handleClose} variant="contained" className={classes.buttonBack}>
                                        Cancelar
                                    </Button>
                                    <Button type='submit' variant="contained"  className={classes.button}>
                                        Confirmar
                                    </Button>
                                </Grid>

                            </Grid>



                        </form>
                        }
                        {/* <Login /> */}
                        {this.props.loading === true &&
                                    // <div className="loading-indicator">
                                    <div style={{textAlign:'center'}}>
                                        <CircularProgress className={classes.progress} />

                                    </div>
                                }

                    </DialogContent>
                    {/* <DialogActions>
                       
                        
                    </DialogActions> */}
                </Dialog>
            </div>
        );
    }
}

BudgetRequest.propTypes = {
    fullScreen: PropTypes.bool.isRequired,
    classes: PropTypes.object.isRequired,
};

export default withStyles(styles)(withMobileDialog()(BudgetRequest));